import Swiper from '../../vendor/swiper/js/swiper';

console.log('Blog.js loaded');

document.addEventListener('DOMContentLoaded', function() {
    
    var headingElements = document.getElementsByClassName('c-blog-item-title');
    var metaElements = document.getElementsByClassName('c-blog-item-meta');
    var headings = Array.prototype.slice.call(headingElements).map(function(el) {
        return el.innerText;
    });
    var swiperHeading = document.getElementById('swiper-heading');
    
    var swiper = new Swiper('#blog-swiper', {
        grabCursor: true,
        autoHeight: true,
        pagination: {
            el: '.c-blog-entries',
            clickable: true,
            renderBullet: function(index, className) {
                return '<li class="' + className + '">' + metaElements[index].innerHTML + '<h6>' + headings[index] + '</h6></li>';
            }
        },
        on: {
            slideChange: function() {
                swiperHeading.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
    });
});